import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthenticationFacade } from '@planone/bau365/data-access-authentication';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { searchPageClosed, searchPageOpened } from '@planone/bau365/data-access-search';
import * as FeatureTrackingGoogleAnalytics from '@planone/shared/feature-tracking-google-analytics';
import * as FeatureTrackingSnowplow from '@planone/shared/feature-tracking-snowplow';
import { delay, distinctUntilKeyChanged, of, switchMap, withLatestFrom } from 'rxjs';

import { CustomEventIglu } from '../../tracking-types/snowplow/schema/schema.interface';

@Injectable()
export class DiscoverEffects {
  searchPageView$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchPageOpened, searchPageClosed),
      distinctUntilKeyChanged('type'),
      ofType(searchPageOpened),
      delay(0), // delay needed to skip to the next frame since the opened action is fired from the resolver and title and url are not updated yet
      withLatestFrom(this.fairsFacade.fairId$),
      withLatestFrom(this.authenticationFacade.excludeAnalytics$),
      switchMap(([[_, fairId], exclude_analytics]) =>
        of(
          FeatureTrackingSnowplow.pageView({
            title: this.title.getTitle(),
            context: [
              {
                schema: CustomEventIglu.page_view,
                data: {
                  context: fairId,
                  page_type: 'discover',
                  exclude_analytics: exclude_analytics,
                },
              },
            ],
          }),
          FeatureTrackingGoogleAnalytics.push({
            event: 'pageview',
            page_type: 'discover',
            title: this.title.getTitle(),
            context: fairId,
            exclude_analytics: exclude_analytics,
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private title: Title,
    private fairsFacade: DataAccessFairsFacade,
    private authenticationFacade: AuthenticationFacade
  ) {}
}
